import React from "react";

const AngleRightIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34.5596"
      height="34.5601"
      viewBox="0 0 34.5596 34.5601"
    >
      {/* <defs>
        <clipPath id="clipPath0401750147">
          <path
            d="M0 0L34.56 0L34.56 34.56L0 34.56L0 0Z"
            fillRule="nonzero"
            transform="matrix(1 0 0 1 0.000272751 -0.00021553)"
          />
        </clipPath>
      </defs> */}
      <g clipPath="url(#clipPath0401750147)">
        <path
          d="M15.4607 -1.06066C14.8749 -1.64644 13.9251 -1.64644 13.3393 -1.06066L-1.06066 13.3393Q-1.11277 13.3915 -1.15952 13.4484Q-1.20626 13.5054 -1.2472 13.5666Q-1.28814 13.6279 -1.32288 13.6929Q-1.35762 13.7579 -1.38582 13.826Q-1.41402 13.8941 -1.43541 13.9646Q-1.4568 14.0351 -1.47118 14.1074Q-1.48555 14.1796 -1.49278 14.253Q-1.5 14.3263 -1.5 14.4Q-1.5 14.4737 -1.49278 14.547Q-1.48555 14.6204 -1.47118 14.6926Q-1.4568 14.7649 -1.43541 14.8354Q-1.41402 14.9059 -1.38582 14.974Q-1.35762 15.0421 -1.32288 15.1071Q-1.28814 15.1721 -1.2472 15.2334Q-1.20626 15.2946 -1.15952 15.3516Q-1.11277 15.4086 -1.06066 15.4607L13.3393 29.8607C13.9251 30.4464 14.8749 30.4464 15.4607 29.8607C16.0464 29.2749 16.0464 28.3251 15.4607 27.7393L2.12132 14.4L15.4607 1.06066C16.0464 0.474878 16.0464 -0.474879 15.4607 -1.06066Z"
          fillRule="evenodd"
          transform="matrix(1 0 0 1 8.64027 2.87976)"
          fill="rgb(255, 255, 255)"
        />
      </g>
    </svg>
  );
};

export default AngleRightIcon;
